// NOTE: Horizon's variant swatches are custom elements that set the hidden
// `id` input's value directly via JS — this does NOT dispatch a `change`
// event, so we can't listen for variant changes. Polling is intentional here.

function syncRinkLocation(form) {
  if (!form) return;
  const formId = form.getAttribute('id');
  if (!formId || !formId.startsWith('BuyButtons-ProductForm-')) return;

  const sectionId = formId.replace('BuyButtons-ProductForm-', '');
  const dataScript = document.getElementById(`RinkLocationData-${sectionId}`);
  const propertyInput = form.elements['properties[Rink Location]'];
  const variantInput = form.elements['id'];
  if (!dataScript || !propertyInput || !variantInput) return;

  let data;
  try {
    data = JSON.parse(dataScript.textContent);
  } catch (e) {
    return;
  }

  const newValue = data[String(variantInput.value)] || '';
  if (propertyInput.value !== newValue) {
    propertyInput.value = newValue;
    console.log('[RinkLocation] updated →', variantInput.value, newValue);
  }
}

document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]').forEach((form) => {
  const variantInput = form.elements['id'];
  if (!variantInput) return;

  syncRinkLocation(form); // initial value
  let lastValue = variantInput.value;

  setInterval(() => {
    if (variantInput.value !== lastValue) {
      lastValue = variantInput.value;
      syncRinkLocation(form);
    }
  }, 150);
});